import React, { useEffect, useRef, useState } from "react";
import MenuItemLayout from "./MenuItemLayout";
import partnership from "../../../assets/images/intern_banner.png";
import partnershipMobile from "../../../assets/images/intern-mob.png";
import PartnersCard from "../../../biblio/Cards/PartnersCard";
import { Col, Row } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../apis/store";
import { getAllPartners } from "../../../apis/actions/partners.actions";
import PaginationComponent from "../../../biblio/Pagination/PaginationComponent";
import { scroll } from "../../../components/utils/utils";
import Loader from "../../../biblio/Loader/Loader";

const PartnersList = () => {
  const dispatch = useDispatch<AppDispatch>();
  const currentRef = useRef<HTMLDivElement>(null);
  const { partners, loading } = useSelector(
    (state: RootState) => state?.partners
  );

  const [currentPage, setCurrentPage] = useState(1);

  const updateActive = (nb: number) => {
    setCurrentPage(nb);
    scroll(currentRef);
  };

  useEffect(() => {
    dispatch(getAllPartners());
  }, [dispatch]);

  const itemPerPage = 8;
  const startIndex = (currentPage - 1) * itemPerPage;
  const allParetners = partners.slice(startIndex, startIndex + itemPerPage);

  if (loading) return <Loader />;

  return (
    <MenuItemLayout
      mobileImage={partnershipMobile}
      title="الشراكات"
      subTitle="قائمة الشراكات"
      urlImage={partnership}
      className="takaful--add-partnership"
    >
      <Row
        dir="rtl"
        gutter={[16, 16]} 
        className="takaful--reports-container"
        ref={currentRef}
        style={{margin:"1.5rem"}}
      >
        {allParetners?.map((partner: any, index: number) => (
          <Col
            key={partner.id || index}
            xxl={6}
            xl={6}
            lg={12}
            md={12}
            sm={24}
            xs={24}
            style={{marginTop:"1rem"}}
          >
            <PartnersCard partner={partner} />
          </Col>
        ))}
      </Row>
      <div className="takaful--pagination-container">
        {partners && partners.length > itemPerPage && (
          <PaginationComponent
            active={currentPage}
            total={partners.length}
            itemPerPage={itemPerPage}
            scroll={() => scroll(currentRef)}
            setActive={(nb) => updateActive(nb)}
          />
        )}
      </div>
    </MenuItemLayout>
  );
};

export default PartnersList;
